import { render, staticRenderFns } from "./LunBoTu.vue?vue&type=template&id=a2aa264e&scoped=true&"
import script from "./LunBoTu.vue?vue&type=script&lang=js&"
export * from "./LunBoTu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2aa264e",
  null
  
)

export default component.exports